import type { MarketRegionResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { EditRegionForm } from "Market/Components/Form/EditRegionForm";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

type EditRegionModalProps = {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	region: MarketRegionResponseDto;
};

const regionResource = Resources.base.market.forms.region;

export const EditRegionModal = ({
	isOpen,
	setIsOpen,
	region,
}: EditRegionModalProps) => {
	const { t } = useResource();
	const handleCancel = () => {
		setIsOpen(false);
	};

	return (
		<Dialog
			open={isOpen}
			onClose={handleCancel}
			slotProps={{
				paper: {
					sx: {
						minWidth: 500,
						width: "100%",
					},
				},
			}}
		>
			<DialogTitle>{t(regionResource.edit)}</DialogTitle>
			<DialogContent sx={{ pb: 1 }}>
				<EditRegionForm region={region} handleCancel={handleCancel} />
			</DialogContent>
		</Dialog>
	);
};
